import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locale/en.json";
import {
    DEFAULT_LANGUAGE,
    getInitialLanguage,
    LANGUAGE,
    SUPPORTED_LANGUAGES,
} from "./locale/language";
import ru from "./locale/ru.json";

void i18next.use(initReactI18next).init({
    resources: {
        [LANGUAGE.en]: { translation: en },
        [LANGUAGE.ru]: { translation: ru },
    },
    lng: getInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

export default i18next;
